import React from "react";
const TextArea = React.forwardRef(
  (
    {
      className = "block mb-4",
      labelKey,
      name,
      errorKey,
      placeholderKey,
      variant = "normal",
      shadow = false,
      type = "text",
      inputClassName,
      ...rest
    },
    ref
  ) => {
    return (
      <div className="w-full ">
        {labelKey && (
          <label
            htmlFor={name}
            className="block text-darkGrey/50 font-normal text-sm leading-none mb-2 "
          >
            {labelKey}
          </label>
        )}
        <textarea
          id={name}
          name={name}
          type={type}
          ref={ref}
          // @ts-ignore
          placeholder={placeholderKey}
          className="resize-none w-full shrink-0 lg:py-4 py-2 px-4 placeholder:text-darkGrey/50 md:placeholder:text-sm placeholder:text-xs text-sm focus:outline-none outline-none text-darkGrey rounded-3xl bg-inherit border-[0.5px] border-solid border-darkGrey/50"
          autoComplete="off"
          spellCheck="false"
          aria-invalid={errorKey ? "true" : "false"}
          rows={3}
          {...rest}
        />
        {errorKey && <p className="text-xs text-red-500">{errorKey}</p>}
      </div>
    );
  }
);
TextArea.displayName = "TextArea";
export default TextArea;
